import React from "react"

import { type Theme, css } from "@emotion/react"
import type { Interpolation } from "@emotion/serialize"
import { Button } from "antd"

export const ButtonElement: React.FunctionComponent<
    IButtonElementProps
> = props => {
    return (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            <Button
                css={props.buttonCss}
                // TO HAVE MORE CONTROL OVER THIS since Ant doesn't add these classes sometimes
                className={`
                    ant-btn-${props.size || "large"}
                    ant-btn-${props.type}
                    ${props.buttonClassName}
                `}
                type={props.type}
                htmlType={props.htmlType}
                size={props.size || "large"}
                icon={
                    props.icon && !props.isRightIcon ? (
                        typeof props.icon === "string" ? (
                            <img
                                src={props.icon}
                                alt={props.label}
                                css={styles.icon}
                                className={props.iconClassName}
                            />
                        ) : (
                            props.icon
                        )
                    ) : undefined
                }
                onClick={props.onClick}
                loading={!!props.isLoading}
                disabled={props.disabled}
                danger={!!props.isDanger}
                aria-pressed={props.ariaPressed}
                aria-selected={props.ariaSelected}
                role={props.role}
            >
                {props.children ?? props.label}

                {props.isRightIcon && props.icon ? (
                    typeof props.icon === "string" ? (
                        <img
                            src={props.icon}
                            alt={props.label}
                            css={styles.rightIcon}
                            className={props.iconClassName}
                        />
                    ) : (
                        props.icon
                    )
                ) : null}
            </Button>
        </div>
    )
}

const styles = {
    icon: css({
        display: "inline-block",
        marginRight: 8,
    }),
    rightIcon: css({
        display: "inline-block",
        marginLeft: 8,
    }),
}

interface IButtonElementProps {
    className?: string
    buttonCss?: Interpolation<Theme>
    buttonClassName?: string
    label?: string
    children?: React.ReactNode
    ariaPressed?: boolean
    ariaSelected?: boolean
    role?: React.AriaRole
    type?: "default" | "primary" | "ghost" | "dashed" | "link" | "text"
    htmlType?: "submit" | "button" | "reset"
    size?: "large" | "middle" | "small"
    isLoading?: boolean
    icon?: string | React.ReactNode
    isRightIcon?: boolean
    iconClassName?: string
    onClick?: React.MouseEventHandler<HTMLElement>
    disabled?: boolean
    isDanger?: boolean
}
